angular.module('components.editor', [
  'components.editor.EditorController'
])

/**
 * The EditorDirective provides a directive to embed
 * the ACE Editor (https://ace.c9.io).  This instance is specific to editing
 * JSON data.
 *
 * @class component-editor
 * @constructor
 * @module components.editor
 * @example
 *   <component-editor
 *     model="model">
 *   </component-editor>
 */
.directive('componentEditor', [
  function () {
    'use strict';

    return {
      restrict: 'E',
      replace: true,
      scope: {
        model: '='
      },
      templateUrl: function () {
        return 'components/editor/editor.html';
      },
      controller: 'EditorController'
    };
  }
]);
